module.exports = __webpack_public_path__ + "img/premium.1bc65301.png";